export default "__VITE_ASSET__Dzj7Fs2$__"